import classNames from './EnlargeBtn.module.scss';
import SVG from 'react-inlinesvg';
import closeIcon from '@/assets/svg/closeBigger.svg';
import { createPortal } from 'react-dom';

interface EnlargeImageProps {
  imageUrl: string;
  onClose: () => void;
}

export default function EnlargeImage({ imageUrl, onClose }: EnlargeImageProps) {
  return createPortal(
    <div className={classNames.overlay}>
      <div className={classNames.imageContainer}>
        <img src={imageUrl} alt='Full Size' className={classNames.image} onClick={onClose} />
        <button className={classNames.closeButton} onClick={onClose}>
          <SVG src={closeIcon} />
        </button>
      </div>
    </div>,
    document.body
  );
}
